import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'chatbot-audio-setting',
    templateUrl: './audio-setting.component.html',
    styleUrls: ['./audio-setting.component.less']
})
export class AudioSettingComponent implements OnInit {

    @Input() voiceIndex: number = 0;
    @Input() voiceList: any[] = [];

    constructor() {
    }

    ngOnInit() {
    }
}
